// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
// } from "recharts";

// function Dashboard({ currentUser }) {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);



  

//   // ----- Common States -----
//   const [products, setProducts] = useState([]);
//   const [logs, setLogs] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [forms, setForms] = useState([]);

//   // ----- Agent / Verifier States -----
//   const [range, setRange] = useState("today"); // today | week | month
//   const [agentData, setAgentData] = useState([]);
//   const [formsChart, setFormsChart] = useState([]);
//   const [stats, setStats] = useState({
//     calls: 0,
//     sales: 0,
//     products: 0,
//     conv: 0,
//   });

//   const COLORS = ["#1abc9c", "#3498db", "#9b59b6", "#f39c12", "#e74c3c"];

//   const isAgent = currentUser?.role === "Agent";
//   const isVerifier = currentUser?.role === "Verifier";

//   // Helper: date filter function
 

//   // ----- Agent/Verifier Dashboard -----
// useEffect(() => {
//   if (!(isAgent || isVerifier)) return;

//   const getStartDate = () => {
//     const today = new Date();
//     if (range === "today") return new Date(today.setHours(0, 0, 0, 0));
//     if (range === "week") {
//       today.setDate(today.getDate() - 7);
//       return new Date(today.setHours(0, 0, 0, 0));
//     }
//     if (range === "month") {
//       today.setDate(today.getDate() - 30);
//       return new Date(today.setHours(0, 0, 0, 0));
//     }
//     return new Date(0);
//   };


  
//   const fetchAgentData = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get("https://crm-server-htk6.vercel.app/api/agents");
//       const allAgents = res.data || [];

//       const start = getStartDate();
//       const fullName =
//         (currentUser?.firstName || "").trim() +
//         " " +
//         (currentUser?.lastName || "").trim();

//       const filtered = allAgents.filter((a) => {
//         const date = new Date(a.submittedDate);
//         const nameMatch = isAgent
//           ? (a.agentName || "").trim() === fullName
//           : (a.verifName || "").trim() === fullName;
//         return date >= start && nameMatch;
//       });

//       // Stats and other logic unchanged...
//       const calls = filtered.length;
//       const sales = filtered.filter((f) => f.disposition === "Sale").length;
//       const productCount = filtered.reduce((acc, f) => {
//         if (f.product) {
//           acc += f.product.split(",").filter((p) => p.trim()).length;
//         }
//         return acc;
//       }, 0);
//       const conv = calls > 0 ? ((sales / calls) * 100).toFixed(2) : 0;

//       const cityCounts = filtered.reduce((acc, f) => {
//         const city = f.city || "Unknown";
//         acc[city] = (acc[city] || 0) + 1;
//         return acc;
//       }, {});
//       const cityChart = Object.entries(cityCounts).map(([city, count]) => ({
//         city,
//         count,
//       }));

//       setAgentData(filtered);
//       setFormsChart(cityChart);
//       setStats({ calls, sales, products: productCount, conv });
//     } catch (err) {
//       console.error("❌ Error fetching agent/verifier data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchAgentData();
// }, [range, currentUser, isAgent, isVerifier]);


//   // ----- Existing Dashboard for other roles -----
//   useEffect(() => {
//     if (isAgent || isVerifier) return;

//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const centerName = (currentUser?.center || "").trim().toLowerCase();

//         const [resProducts, resLogs, resUsers, resForms] = await Promise.all([
//           axios.get("https://crm-server-htk6.vercel.app/api/products"),
//           axios.get("https://crm-server-htk6.vercel.app/api/logs"),
//           axios.get("https://crm-server-htk6.vercel.app/api/users"),
//           axios.get("https://crm-server-htk6.vercel.app/api/agents"),
//         ]);

//         const filteredLogs = (resLogs.data || []).filter(
//           (l) =>
//             (l.userCenter || "").trim().toLowerCase() === centerName
//         );
//         const filteredUsers = (resUsers.data || []).filter(
//           (u) => (u.center || "").trim().toLowerCase() === centerName
//         );
//         const filteredForms = (resForms.data || []).filter(
//           (f) => (f.centerName || "").trim().toLowerCase() === centerName
//         );

//         setProducts(resProducts.data || []);
//         setLogs(filteredLogs);
//         setUsers(filteredUsers);
//         setForms(filteredForms);
//       } catch (err) {
//         console.error("❌ Error fetching dashboard data:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (currentUser?.center) fetchData();
//   }, [currentUser, isAgent, isVerifier]);

//   if (loading)
//     return (
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           width: "100vw",
//           height: "100vh",
//           background: "rgba(0,0,0,0.5)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           zIndex: 9999,
//           color: "#fff",
//           fontSize: "24px",
//           fontWeight: "bold",
//         }}
//       >
//         ⏳ Loading Dashboard...
//       </div>
//     );

//   // ---------- Agent / Verifier DASH ----------
//   if (isAgent || isVerifier) {
//     return (
//       <div className="dashboard">
//         <h2>📊 {isAgent ? "Agent" : "Verifier"} Dashboard</h2>

//         {/* Date Range Selector */}
//         <div style={{ marginBottom: "15px" }}>
//           <label><strong>Range: </strong></label>
//           <select
//             value={range}
//             onChange={(e) => setRange(e.target.value)}
//             style={{ padding: "6px", marginLeft: "10px" }}
//           >
//             <option value="today">Today</option>
//             <option value="week">Last 1 Week</option>
//             <option value="month">Last 1 Month</option>
//           </select>
//         </div>


//         {/* Stats Tiles */}
//         <div className="summary-tiles">
//           <div className="tile small"><h4>Calls</h4><p>{stats.calls}</p></div>
//           <div className="tile small"><h4>Sales</h4><p>{stats.sales}</p></div>
//           <div className="tile small"><h4>Products</h4><p>{stats.products}</p></div>
//           <div className="tile small"><h4>Conversion %</h4><p>{stats.conv}</p></div>
//         </div>

//         {/* Calls Trend */}
//         <div className="tile large">
//           <h3>Calls Trend</h3>
//           <ResponsiveContainer width="100%" height={250}>
//             <LineChart
//               data={agentData.map((d) => ({
//                 date: new Date(d.submittedDate).toLocaleDateString(),
//                 count: 1,
//               }))}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="date" />
//               <YAxis allowDecimals={false} />
//               <Tooltip />
//               <Line type="monotone" dataKey="count" stroke="#3498db" />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>

//         {/* Forms by City */}
//         <div className="tile wide">
//           <h3>Forms by City</h3>
//           <ResponsiveContainer width="100%" height={250}>
//             <BarChart data={formsChart}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="city" />
//               <YAxis allowDecimals={false} />
//               <Tooltip />
//               <Bar dataKey="count" fill="#9b59b6" radius={[6, 6, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>

//         {/* --- Current User Info --- */}
//         <div className="user-info-card">
//           <h3>👤 Logged In User</h3>
//           <p><strong>Name:</strong> {currentUser?.firstName} {currentUser?.lastName}</p>
//           <p><strong>Emp Code:</strong> {currentUser?.empCode}</p>
//           <p><strong>Role:</strong> {currentUser?.role}</p>
//           <p><strong>Center:</strong> {currentUser?.center}</p>
//         </div>
//       </div>
//     );
//   }

//   // ---------- DEFAULT DASH (Other Roles) ----------
//   const productChart = products.map((p) => ({ name: p.productName, qty: p.qty || 0 }));
//   const logsByDate = logs.reduce((acc, log) => {
//     const date = new Date(log.logDate).toLocaleDateString();
//     acc[date] = (acc[date] || 0) + 1;
//     return acc;
//   }, {});
//   const logsChart = Object.entries(logsByDate).map(([date, count]) => ({ date, count }));
//   const rolesCount = users.reduce((acc, u) => {
//     acc[u.role] = (acc[u.role] || 0) + 1;
//     return acc;
//   }, {});
//   const rolesChart = Object.entries(rolesCount).map(([role, count], i) => ({
//     name: role,
//     value: count,
//     color: COLORS[i % COLORS.length],
//   }));
//   const formsByCity = forms.reduce((acc, f) => {
//     const city = f.city || "Unknown";
//     acc[city] = (acc[city] || 0) + 1;
//     return acc;
//   }, {});
//   const formsDefaultChart = Object.entries(formsByCity).map(([city, count]) => ({
//     city,
//     count,
//   }));

//   return (
//     <div className="dashboard">
//    <h2>📊 Dashboard</h2>
    

//       <div className="summary-tiles">
//         <div className="tile small" onClick={() => navigate("/product")}><h4>Products</h4><p>{products.length}</p></div>
//         <div className="tile small" onClick={() => navigate("/logs")}><h4>Logs</h4><p>{logs.length}</p></div>
//         <div className="tile small" onClick={() => navigate("/user")}><h4>Users</h4><p>{users.length}</p></div>
//         <div className="tile small" onClick={() => navigate("/all")}><h4>Forms</h4><p>{forms.length}</p></div>
        
//       </div>

//       <div className="charts-grid">
//         <div className="tile large">
//           <h3>Products Qty</h3>
//           <ResponsiveContainer width="100%" height={250}>
//             <BarChart data={productChart}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="name" />
//               <YAxis />
//               <Tooltip />
//               <Bar dataKey="qty" fill="#3498db" radius={[6, 6, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>

//         <div className="tile large">
//           <h3>Logs by Date</h3>
//           <ResponsiveContainer width="100%" height={250}>
//             <LineChart data={logsChart}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="date" />
//               <YAxis />
//               <Tooltip />
//               <Line type="monotone" dataKey="count" stroke="#e67e22" />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>

//         <div className="tile wide">
//           <h3>Users by Role</h3>
//           <ResponsiveContainer width="100%" height={250}>
//             <PieChart>
//               <Pie data={rolesChart} dataKey="value" outerRadius={80} label>
//                 {rolesChart.map((entry, i) => (
//                   <Cell key={i} fill={entry.color} />
//                 ))}
//               </Pie>
//               <Tooltip />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>

//         <div className="tile wide">
//           <h3>Forms by City</h3>
//           <ResponsiveContainer width="100%" height={250}>
//             <BarChart data={formsDefaultChart}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="city" />
//               <YAxis />
//               <Tooltip />
//               <Bar dataKey="count" fill="#9b59b6" radius={[6, 6, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       <div className="user-info-card">
//         <h3>👤 Logged In User</h3>
//         <p><strong>Name:</strong> {currentUser?.firstName}</p>
//         <p><strong>Emp Code:</strong> {currentUser?.empCode}</p>
//         <p><strong>Role:</strong> {currentUser?.role}</p>
//         <p><strong>Center:</strong> {currentUser?.center}</p>
//       </div>
//     </div>
//   );
// }

// export default Dashboard;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";

function Dashboard({ currentUser }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // ----- Common States -----
  const [products, setProducts] = useState([]);
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [forms, setForms] = useState([]);

  // ----- Agent / Verifier States -----
  const [range, setRange] = useState("today"); // today | week | month
  const [agentData, setAgentData] = useState([]);
  const [formsChart, setFormsChart] = useState([]);
  const [stats, setStats] = useState({
    calls: 0,
    sales: 0,
    products: 0,
    conv: 0,
  });

  const COLORS = ["#1abc9c", "#3498db", "#9b59b6", "#f39c12", "#e74c3c"];
  const isAgent = currentUser?.role === "Agent";
  const isVerifier = currentUser?.role === "Verifier";

  // ----- Agent/Verifier Dashboard -----
  useEffect(() => {
    if (!(isAgent || isVerifier) || !currentUser) return;

    const fetchAgentDashboard = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          "https://crm-server-htk6.vercel.app/api/agents/dashboard",
          {
            params: {
              userId: currentUser._id,
              role: currentUser.role,
              range,
            },
          }
        );

        setAgentData(res.data.agents || []);
        setFormsChart(res.data.cityChart || []);
        setStats(res.data.stats || { calls: 0, sales: 0, products: 0, conv: 0 });
      } catch (err) {
        console.error("❌ Error fetching agent dashboard:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentDashboard();
  }, [range, currentUser, isAgent, isVerifier]);

  // ----- Other Roles Dashboard -----
  useEffect(() => {
    if (isAgent || isVerifier || !currentUser?.center) return;

    const fetchAllDashboard = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          "https://crm-server-htk6.vercel.app/api/dashboard/all",
          { params: { center: currentUser.center } }
        );

        setProducts(res.data.products || []);
        setLogs(res.data.logs || []);
        setUsers(res.data.users || []);
        setForms(res.data.forms || []);
      } catch (err) {
        console.error("❌ Error fetching all dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllDashboard();
  }, [currentUser, isAgent, isVerifier]);

  if (loading)
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          color: "#fff",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        ⏳ Loading Dashboard...
      </div>
    );

  // ---------- Agent / Verifier DASH ----------
  if (isAgent || isVerifier) {
    return (
      <div className="dashboard">
        <h2>📊 {isAgent ? "Agent" : "Verifier"} Dashboard</h2>

        {/* Date Range Selector */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Range: </strong></label>
          <select
            value={range}
            onChange={(e) => setRange(e.target.value)}
            style={{ padding: "6px", marginLeft: "10px" }}
          >
            <option value="today">Today</option>
            <option value="week">Last 1 Week</option>
            <option value="month">Last 1 Month</option>
          </select>
        </div>

        {/* Stats Tiles */}
        <div className="summary-tiles">
          <div className="tile small"><h4>Calls</h4><p>{stats.calls}</p></div>
          <div className="tile small"><h4>Sales</h4><p>{stats.sales}</p></div>
          <div className="tile small"><h4>Products</h4><p>{stats.products}</p></div>
          <div className="tile small"><h4>Conversion %</h4><p>{stats.conv}</p></div>
        </div>

        {/* Calls Trend */}
        <div className="tile large">
          <h3>Calls Trend</h3>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart
              data={agentData.map((d) => ({
                date: new Date(d.submittedDate).toLocaleDateString(),
                count: 1,
              }))}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#3498db" />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Forms by City */}
        <div className="tile wide">
          <h3>Forms by City</h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={formsChart}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="city" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="count" fill="#9b59b6" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* --- Current User Info --- */}
        <div className="user-info-card">
          <h3>👤 Logged In User</h3>
          <p><strong>Name:</strong> {currentUser?.firstName} {currentUser?.lastName}</p>
          <p><strong>Emp Code:</strong> {currentUser?.empCode}</p>
          <p><strong>Role:</strong> {currentUser?.role}</p>
          <p><strong>Center:</strong> {currentUser?.center}</p>
        </div>
      </div>
    );
  }

  // ---------- DEFAULT DASH (Other Roles) ----------
  const productChart = products.map((p) => ({ name: p.productName, qty: p.qty || 0 }));
  const logsByDate = logs.reduce((acc, log) => {
    const date = new Date(log.logDate).toLocaleDateString();
    acc[date] = (acc[date] || 0) + 1;
    return acc;
  }, {});
  const logsChart = Object.entries(logsByDate).map(([date, count]) => ({ date, count }));
  const rolesCount = users.reduce((acc, u) => {
    acc[u.role] = (acc[u.role] || 0) + 1;
    return acc;
  }, {});
  const rolesChart = Object.entries(rolesCount).map(([role, count], i) => ({
    name: role,
    value: count,
    color: COLORS[i % COLORS.length],
  }));
  const formsByCity = forms.reduce((acc, f) => {
    const city = f.city || "Unknown";
    acc[city] = (acc[city] || 0) + 1;
    return acc;
  }, {});
  const formsDefaultChart = Object.entries(formsByCity).map(([city, count]) => ({
    city,
    count,
  }));

  return (
    <div className="dashboard">
      <h2>📊 Dashboard</h2>

      <div className="summary-tiles">
        <div className="tile small" onClick={() => navigate("/product")}><h4>Products</h4><p>{products.length}</p></div>
        <div className="tile small" onClick={() => navigate("/logs")}><h4>Logs</h4><p>{logs.length}</p></div>
        <div className="tile small" onClick={() => navigate("/user")}><h4>Users</h4><p>{users.length}</p></div>
        <div className="tile small" onClick={() => navigate("/all")}><h4>Forms</h4><p>{forms.length}</p></div>
      </div>

      <div className="charts-grid">
        <div className="tile large">
          <h3>Products Qty</h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={productChart}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="qty" fill="#3498db" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="tile large">
          <h3>Logs by Date</h3>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={logsChart}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#e67e22" />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="tile wide">
          <h3>Users by Role</h3>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={rolesChart} dataKey="value" outerRadius={80} label>
                {rolesChart.map((entry, i) => (
                  <Cell key={i} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="tile wide">
          <h3>Forms by City</h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={formsDefaultChart}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="city" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#9b59b6" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="user-info-card">
        <h3>👤 Logged In User</h3>
        <p><strong>Name:</strong> {currentUser?.firstName}</p>
        <p><strong>Emp Code:</strong> {currentUser?.empCode}</p>
        <p><strong>Role:</strong> {currentUser?.role}</p>
        <p><strong>Center:</strong> {currentUser?.center}</p>
      </div>
    </div>
  );
}

export default Dashboard;
